import { useState } from "react";

import InputRadio from "components/atoms/input/Radio";
import InputText from "components/atoms/input/Text";
import Buttons from "components/atoms/buttons";
import Modal from "components/organisms/Modal";
import ModalFindID from "components/templates/findId/ModalFindID";

import useInput from "hooks/useInput";

import useUserForgotId from "apis/mutations/user/useForgotId";
import useCompanyForgotId from "apis/mutations/company/useForgotId";

const Form = () => {
  const [userType, setUserType] = useState("user");
  const [infoState, dispatch] = useInput({ name: "", email: "" });
  const [errorMessage, setErrorMessage] = useState<
    undefined | string | string[]
  >("");
  const [userName, setUserName] = useState("");

  const { name, email } = infoState;

  // 아이디찾기 api - 일반회원
  const userForgotId = useUserForgotId({
    onError: (message) => {
      setErrorMessage(message);
    },
  });

  // 아이디찾기 api - 전문가회원
  const companyForgotId = useCompanyForgotId({
    onError: (message) => {
      setErrorMessage(message);
    },
  });

  // 아이디찾기
  const handleFindId = (onOpen: () => void) => {
    if (!name) return setErrorMessage("이름을 작성해주세요");
    if (!email) return setErrorMessage("이메일을 작성해주세요");

    const onSuccess = (data: { userName: string }) => {
      setUserName(data.userName);
      onOpen();
    };

    if (userType === "user") {
      userForgotId(infoState, {
        onSuccess,
      });
    } else {
      const newInfoState = {
        managerName: name,
        email,
      };
      companyForgotId(newInfoState, {
        onSuccess,
      });
    }
  };

  return (
    <form>
      <div className="flex items-center gap-4 mb-5">
        <InputRadio
          name="loginType"
          value="user"
          labelText="일반회원"
          onChange={() => setUserType("user")}
          checked={userType === "user"}
        />
        <InputRadio
          name="loginType"
          value="company"
          labelText="전문가회원"
          onChange={() => setUserType("company")}
          checked={userType === "company"}
        />
      </div>

      <InputText
        placeholder="이름을 입력하세요"
        className={{ container: "mb-3" }}
        name="name"
        value={name}
        onChange={(event) => dispatch({ event })}
        shape="square"
      />
      <InputText
        placeholder="이메일을 입력하세요"
        name="email"
        value={email}
        onChange={(event) => dispatch({ event })}
        shape="square"
      />

      {errorMessage && (
        <p className="mt-1 ml-2 text-error-active">{errorMessage}</p>
      )}

      <Modal
        modal={(onClose) => <ModalFindID userName={userName} />}
        activator={(onOpen) => (
          <Buttons.Blue
            size="large"
            className="w-full mt-5 mx-auto"
            type="button"
            onClick={() => handleFindId(onOpen)}
          >
            확인하기
          </Buttons.Blue>
        )}
      />
    </form>
  );
};

export default Form;
